export default class Alert {

    danger(text) {
        let element = $('.content-error');
        element.find('.Polaris-BlockStack div').html(text);
        return element.html();
    }
}
